module.exports = __webpack_public_path__ + "static/media/icon_comments.47c61223.svg";